import { AppHelper } from '../helpers/env-helper';
var LocalStorageService = /** @class */ (function () {
    function LocalStorageService() {
        this.localStorage = window.localStorage;
        this.sessionStorage = window.sessionStorage;
    }
    LocalStorageService.singleton = function () {
        if (!LocalStorageService.localStorageService) {
            LocalStorageService.localStorageService = new LocalStorageService();
        }
        return LocalStorageService.localStorageService;
    };
    LocalStorageService.prototype.has = function (itemName) {
        var systStorage = this.getSystemStorage().systStorage;
        if (!systStorage || !systStorage[itemName]) {
            return false;
        }
        return systStorage[itemName] != null;
    };
    LocalStorageService.prototype.getItem = function (itemName) {
        var systStorage = this.getSystemStorage().systStorage;
        return systStorage[itemName];
    };
    LocalStorageService.prototype.setItem = function (itemName, itemData, systemData) {
        var systToken = this.getSystemStorage().systToken;
        if (!this.isValid(itemData)) {
            console.error('Valor inesperado para ', itemName, '. Valor informado =', itemData);
            return false;
        }
        if (systemData || !systToken || itemName === systToken) {
            return this.setSystemData(itemName, this.sanitizeData(itemData));
        }
        return this.setItemData(itemName, itemData);
    };
    LocalStorageService.prototype.getSystemAtivoToken = function () {
        return this.sessionStorage.getItem('sist_ativo_token');
    };
    LocalStorageService.prototype.setSystemAtivoToken = function (systToken) {
        if (!AppHelper.getAppByAppHash(systToken)) {
            console.error('Valor inesperado para sist_ativo_token. Valor informado =', systToken);
            return;
        }
        this.sessionStorage.setItem('sist_ativo_token', systToken);
    };
    LocalStorageService.prototype.setItemData = function (itemName, itemData) {
        var _a = this.getSystemStorage(), systToken = _a.systToken, systStorage = _a.systStorage;
        systStorage[itemName] = itemData;
        this.localStorage.setItem(systToken, this.sanitizeData(systStorage));
    };
    LocalStorageService.prototype.setSystemData = function (systToken, itemData) {
        this.setSystemAtivoToken(systToken);
        this.localStorage.setItem(systToken, itemData);
    };
    LocalStorageService.prototype.getSystemStorage = function () {
        var systToken = window.sessionStorage.getItem('sist_ativo_token') || '';
        var systStorage = JSON.parse(this.localStorage.getItem(systToken)) || {};
        return { systToken: systToken, systStorage: systStorage };
    };
    LocalStorageService.prototype.isValid = function (data) {
        if (typeof data === 'undefined') {
            return false;
        }
        if (data === null) {
            return false;
        }
        return true;
    };
    LocalStorageService.prototype.sanitizeData = function (data) {
        if (typeof data === 'string' || data === null) {
            return data;
        }
        return JSON.stringify(data);
    };
    LocalStorageService.prototype.deleteItem = function (itemName) {
        var _a = this.getSystemStorage(), systToken = _a.systToken, systStorage = _a.systStorage;
        if (!systStorage) {
            this.localStorage.removeItem(itemName);
            return;
        }
        delete systStorage[itemName];
        this.localStorage.setItem(systToken, this.sanitizeData(systStorage));
    };
    LocalStorageService.prototype.clear = function () {
        var systToken = this.getSystemStorage().systToken;
        this.localStorage.removeItem(systToken);
    };
    LocalStorageService.prototype.clearAll = function () {
        this.localStorage.clear();
        this.sessionStorage.clear();
    };
    return LocalStorageService;
}());
export { LocalStorageService };
